import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import moment from 'moment';
import { toUniversalUtcDate } from '../../../../utils/date.utils';

const SummaryPolicyDuration = ({
  endDate,
  term,
  policyDetails,
  originalPolicyDetails,
}: any) => {
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <Box className={classes.subHeader}>
        <Typography className={classes.subHeaderTitle}>
          Policy Duration
        </Typography>
      </Box>

      <Grid
        container
        spacing={6}
        className={classes.AI}
        justifyContent="space-between"
      >
        <Grid item md={2} />
        <Grid
          item
          md={10}
          container
          spacing={6}
          style={{ paddingLeft: '3rem' }}
        >
          <Grid item md={3}>
            <Grid>Current</Grid>
          </Grid>
          <Grid item md={7}>
            Endorsement
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={6}
        className={classes.AI}
        justifyContent="space-between"
      >
        <Grid item md={2}>
          Policy End Date
        </Grid>
        <Grid
          item
          md={10}
          container
          spacing={6}
          style={{ paddingLeft: '3rem' }}
        >
          <Grid item md={3}>
            <Grid>{toUniversalUtcDate(policyDetails.endDate)}</Grid>
          </Grid>
          <Grid item md={7}>
            {toUniversalUtcDate(endDate)}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={6}
        className={classes.AI}
        justifyContent="space-between"
      >
        <Grid item md={2}>
          Policy Term
        </Grid>
        <Grid
          item
          md={10}
          container
          spacing={6}
          style={{ paddingLeft: '3rem' }}
        >
          <Grid item md={3}>
            <Grid>
              {moment
                .utc(policyDetails.endDate)
                .diff(
                  moment.utc(originalPolicyDetails.effectiveDate),
                  'days'
                )}{' '}
              days
            </Grid>
          </Grid>
          <Grid item md={7}>
            {term} days
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  AiDivider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  dateGrif: {
    paddingtop: '12px !important',
  },
  AI: {
    fontWeight: 'normal',
    padding: '0 2rem',
    fontSize: config.textSizes.primer,
    color: palette.primary.contrastText,
  },
  subHeader: {
    display: 'flex',
    padding: '0.5em 2em',
    backgroundColor: palette.background.customTable,
    borderRadius: 5,
    lineHeight: 1.4,
    marginBottom: '1.66rem',
  },
  subHeaderTitle: {
    color: palette.primary.contrastText,
    fontSize: config.textSizes.paragon,
    fontWeight: 'normal',
    lineHeight: 1.4,
  },
}));

export default SummaryPolicyDuration;
